import { client } from "./index";

// A store owner's staff: people who log in with only the areas the owner picked
export const getStaff = () => client.get("/admin/staff");
export const createStaff = (payload) => client.post("/admin/staff", payload);
export const updateStaff = (staffId, payload) => client.put(`/admin/staff/${staffId}`, payload);
export const resetStaffPassword = (staffId) => client.post(`/admin/staff/${staffId}/reset-password`);
export const deleteStaff = (staffId) => client.delete(`/admin/staff/${staffId}`);
